
const searchplaceByGeoCode = async (searchText: string): Promise<google.maps.GeocoderResult[] | undefined> => {
  if (searchText.trim() === '') {
    return;
  }

  const geocoder = new window.google.maps.Geocoder();
  if (!geocoder) return

  const results = await geocoder.geocode({ address: searchText }, (results, status) => {
    console.log("Status is ", status)
    if (status === 'OK' && results!.length > 0 && results![0]) {
      return results![0]

    } else {
      // throw new Error(`'Geocode was not successful for the following reason:', ${status}`)
      // Handle geocoding errors
      console.error('Geocode was not successful for the following reason:', status);
    }
  });
  console.log("result is ", results)
  return results.results
}

export default searchplaceByGeoCode